<template>
    <div id="contenedor-estimaciones-listado-desktop">
      <v-data-table
        :headers="getHeaders"
        :items="getEstimaciones"
        :items-per-page="-1">
        <template
          v-slot:[`item.numero`]="{ item }">
          <v-chip
            color="secondary">
            {{ item.numero }}
          </v-chip>
        </template>
        <template
          v-slot:[`item.estatus`]="{ item }">
          <template
            v-if="item.esEstimacionFinPrograma">
            <v-tooltip
              top>
              <template
                v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on">
                  fa-hourglass-end
                </v-icon>
              </template>
              <span>
                Estimación fin de programa
              </span>
            </v-tooltip>
          </template>
          <template
            v-if="item.esEstimacionFiniquito">
            <v-tooltip
              top>
              <template
                v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on">
                  fa-lock
                </v-icon>
              </template>
              <span>
                Estimación finiquito
              </span>
            </v-tooltip>
          </template>
        </template>
        <template
          v-slot:[`item.plazo`]="{ item }">
          <span
            class="font-weight-bold">
            <!-- {{ new Date(`${item.fechaDel} 00:00:0`).toLocaleDateString()  }} -->
            {{ $moment(item.fechaDel).format('D/M/YYYY') }}
          </span> -
          <span
            class="font-weight-bold">
            <!-- {{ new Date(`${item.fechaAl} 00:00:0`).toLocaleDateString() }} -->
            {{ $moment(item.fechaAl).format('D/M/YYYY') }}
          </span>
        </template>
        <template
          v-slot:[`item.importeCostoDirecto`]="{ item }">
          {{ item.importeCostoDirecto | currency }}
        </template>
        <template
          v-slot:[`item.importeCostoIndirectos`]="{ item }">
          {{ item.importeCostoIndirectos | currency }}
        </template>
        <template
          v-slot:[`item.importeUtilidad`]="{ item }">
          {{ item.importeUtilidad | currency }}
        </template>
        <template
          v-slot:[`item.importeCargosAdicionales`]="{ item }">
          {{ item.importeCargosAdicionales | currency }}
        </template>
        <template
          v-slot:[`item.importeEstimado`]="{ item }">
          {{ item.importeEstimado | currency }}
        </template>
        <template
          v-slot:[`item.importeRetenido`]="{ item }">
          <template
            v-if="item.importeRetenido !== 0">
            <v-chip
              color="error"
              small>
              {{ item.importeRetenido | currency }}
            </v-chip>
          </template>
          <template
            v-else>
            {{ item.importeRetenido | currency }}
          </template>
        </template>
        <template
          v-slot:[`item.importeDevuelto`]="{ item }">
          <template
            v-if="item.importeDevuelto !== 0">
            <v-chip
              color="success"
              small>
              {{ item.importeDevuelto | currency }}
            </v-chip>
          </template>
          <template
            v-else>
            {{ item.importeDevuelto | currency }}
          </template>
        </template>
        <template
          v-slot:[`item.importeNeto`]="{ item }">
          {{ item.importeNeto | currency }}
        </template>
        <template
          v-slot:[`item.importeAmortizacionAnticipo`]="{ item }">
          {{ item.importeAmortizacionAnticipo | currency }}
        </template>
        <template
          v-slot:[`item.subtotal`]="{ item }">
          {{ item.subtotal | currency }}
        </template>
        <template
          v-slot:[`item.subtotalDos`]="{ item }">
          {{ item.subtotalDos | currency }}
        </template>
        <template
          v-slot:[`item.importeCostoFinanciero`]="{ item }">
          {{ item.importeCostoFinanciero | currency }}
        </template>
        <template
          v-slot:[`item.importeIva`]="{ item }">
          {{ item.importeIva | currency }}
        </template>
        <template
          v-slot:[`item.totalFactura`]="{ item }">
          {{ item.totalFactura | currency }}
        </template>
        <template
          v-slot:[`item.importeDeducciones`]="{ item }">
          {{ item.importeDeducciones | currency }}
        </template>
        <template
          v-slot:[`item.importeBonificacion`]="{ item }">
          {{ item.importeBonificacion | currency }}
        </template>
        <template
          v-slot:[`item.importeSancion`]="{ item }">
          <template
            v-if="item.importeSancion > 0">
            <v-chip
              small
              color="error"
              dark>
              {{ item.importeSancion | currency }}
            </v-chip>
          </template>
          <template
            v-else>
            {{ item.importeSancion | currency }}
          </template>
        </template>
        <template
          v-slot:[`item.importeLiquido`]="{ item }">
          {{ item.importeLiquido | currency }}
        </template>
        <template
          v-slot:[`item.estatusPago`]="{ item }">
          <estatus-pago
            :solicitud="mixGetSolicitud(item)"
            small>
          </estatus-pago>
        </template>
        <template
          v-slot:[`item.acciones`]="{ item }">
          <v-row justify="end">
            <registrar-remover-pago
              :referencia="item"
              :solicitudPago="mixGetSolicitudDetalles(item)"
            >
            </registrar-remover-pago>
            <v-menu
              bottom
              left>
              <template
                v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list
                subheader>
                <v-subheader>
                  Reportes
                </v-subheader>
                <v-divider></v-divider>
                <v-list-item
                  @click="verRelacionConceptos(item)">
                  <v-list-item-title>
                    Relación de Conceptos
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="verConcentradoEstimaciones(item)">
                  <v-list-item-title>
                    Concentrado de Estimación
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="verControlEstimaciones(item)">
                  <v-list-item-title>
                    Control de Estimación
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="verPenasConvencionales(item)">
                  <v-list-item-title>
                    Penas Convencionales
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="verGraficaAvanceEstimaciones(item)">
                  <v-list-item-title>
                    Gráfica Avance Programado
                  </v-list-item-title>
                </v-list-item>
                <!--
                <v-list-item
                  @click="generarPdfCheckList(item,contrato)">
                  <v-list-item-title>
                    CheckList Documentación
                  </v-list-item-title>
                </v-list-item>
                -->
                <v-list-item
                  @click="verGraficaEstimadoAcumulado(item, getEstimaciones)">
                  <v-list-item-title>
                    Gráfica Estimado Acumulado
                  </v-list-item-title>
                </v-list-item>
                <!--
                <v-list-item
                  @click="descargarTodos(item)">
                  <v-list-item-title>
                    Descargar todo
                  </v-list-item-title>
                </v-list-item>
                -->
                <v-divider v-if="!soloLectura"></v-divider>

                <v-list-item
                  v-if="mixValidaScopesActions(3)"
                  @click="verProgramaObra(item)">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Programa de Obra
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="!soloLectura && mixValidaScopesActions(2)"
                  @click="editarEstimacion(item)">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Editar
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.esUltima && !soloLectura && mixValidaScopesActions(3)"
                  @click="eliminarEstimacion(item)">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Eliminar
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </template>
        <template
          v-slot:[`body.append`]="{ headers }">
          <tr>
            <td
              v-for="item in (headers.length)"
              :key="item"
              class="selected font-weight-bold"
              align="right">
              <template
                v-if="headers[item - 1].seSuma">
                {{ sumarColuma(headers[item -1].value) | currency }}
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import EstatusPago from '@/components/administracion/pagos/EstatusPago.vue';
import checkListDocumentacion from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/checklistdocumentacion/mixCheckListDocumentacion';
import mixDescargaControlEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/controlestimaciones/mixDescargaControlEstimaciones';
import mixDescargaConcentradoEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/concentrado/mixDescargaConcentradoEstimaciones';
import mixDescargaGraficaAvanceEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/graficaavanceestimaciones/mixDescargaGraficaAvanceEstimaciones';
import mixDescargaRelacionConceptos from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/relacionconceptos/mixDescargaRelacionConceptos';
import mixDescargaPenasConvencionales from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/penasconvencionales/mixDescargaPenasConvencionales';
import mixRegistrarRemoverPago from '@/components/administracion/pagos/solicitudes/mixRegistrarRemoverPago';
import RegistrarRemoverPago from '@/components/administracion/pagos/solicitudes/RegistrarRemoverPago.vue';

export default {
  name: 'EstimacionesListadoDesktop',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    EstatusPago,
    RegistrarRemoverPago,
  },
  props: {
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
    programasobra: {
      type: Array,
      required: true,
    },
    esObraFinanciada: {
      type: Boolean,
      required: false,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [checkListDocumentacion,
    mixDescargaControlEstimaciones,
    mixDescargaConcentradoEstimaciones,
    mixDescargaGraficaAvanceEstimaciones,
    mixDescargaRelacionConceptos,
    mixDescargaPenasConvencionales,
    mixRegistrarRemoverPago],
  data() {
    return {
      estimacion: {},
      contratoEstimaciones: [],
      tipoHeader: 0,
      headers: [
        {
          text: 'Número',
          align: 'center',
          sortable: false,
          value: 'numero',
          width: '1%',
          mostrarSmall: true,
          seSuma: false,
          esObraFinanciada: false,
        },
        {
          text: '', align: 'center', value: 'estatus', width: '1%', sortable: false, mostrarSmall: true, seSuma: false, esObraFinanciada: false,
        },
        {
          text: 'Plazo', align: 'center', value: 'plazo', sortable: false, mostrarSmall: true, seSuma: false, esObraFinanciada: false,
        },
        {
          text: 'Directo', align: 'end', value: 'importeCostoDirecto', sortable: false, mostrarSmall: false, seSuma: true, esObraFinanciada: true,
        },
        {
          text: 'Indirectos', align: 'end', value: 'importeCostoIndirectos', sortable: false, mostrarSmall: false, seSuma: true, esObraFinanciada: true,
        },
        {
          text: 'Utilidad', align: 'end', value: 'importeUtilidad', sortable: false, mostrarSmall: false, seSuma: true, esObraFinanciada: true,
        },
        {
          text: 'Adicionales', align: 'end', value: 'importeCargosAdicionales', sortable: false, mostrarSmall: false, seSuma: true, esObraFinanciada: true,
        },
        {
          text: 'Estimado', align: 'end', value: 'importeEstimado', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Amort. Ant.', align: 'end', value: 'importeAmortizacionAnticipo', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Subtotal', align: 'end', value: 'subtotal', sortable: false, mostrarSmall: false, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'C. Financiero', align: 'end', value: 'importeCostoFinanciero', sortable: false, mostrarSmall: false, seSuma: true, esObraFinanciada: true,
        },
        {
          text: 'Subtotal 2', align: 'end', value: 'subtotalDos', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: true,
        },
        {
          text: 'IVA', align: 'end', value: 'importeIva', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Facturado', align: 'end', value: 'totalFactura', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Deducciones', align: 'end', value: 'importeDeducciones', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Retenido', align: 'end', value: 'importeRetenido', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Devuelto', align: 'end', value: 'importeDevuelto', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Sanción', align: 'end', value: 'importeSancion', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Ajuste', align: 'end', value: 'importeBonificacion', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Líquido', align: 'end', value: 'importeLiquido', sortable: false, mostrarSmall: true, seSuma: true, esObraFinanciada: false,
        },
        {
          text: 'Pagada', align: 'center', value: 'estatusPago', sortable: false, mostrarSmall: true, seSuma: false, esObraFinanciada: false,
        },
        {
          text: '', width: '105', align: 'end', value: 'acciones', sortable: false, mostrarSmall: true, seSuma: false, esObraFinanciada: false,
        },
      ],
    };
  },
  mounted() {
    eventBus.$on('estimaciones-cambiar-tipo-lista', (tipo) => {
      this.tipoHeader = tipo;
    });
  },
  methods: {
    verGraficaEstimadoAcumulado(estimacion, estimaciones) {
      eventBus.$emit('ver-grafica-estimado-acumulado', estimacion, estimaciones);
    },
    verProgramaObra(estimacion) {
      eventBus.$emit('ver-programa-obra-estimaciones', estimacion);
    },
    verGraficaAvanceEstimaciones(estimacion) {
      eventBus.$emit('ver-grafica-avance-estimaciones', estimacion);
    },
    verControlEstimaciones(estimacion) {
      eventBus.$emit('ver-control-estimaciones', estimacion);
    },
    verConcentradoEstimaciones(estimacion) {
      eventBus.$emit('ver-concentrado-estimaciones', estimacion);
    },
    verRelacionConceptos(estimacion) {
      eventBus.$emit('ver-relacion-conceptos', estimacion);
    },
    verPenasConvencionales(estimacion) {
      eventBus.$emit('ver-penas-convencionales', estimacion);
    },
    sumarColuma(columna) {
      return this.$ObjSumar(this.estimaciones, columna);
    },
    editarEstimacion(estimacion) {
      // if (!estimacion.esUltima) return;
      eventBus.$emit('editar-estimacion-contrato', estimacion);
    },
    eliminarEstimacion(estimacion) {
      if (!estimacion.esUltima) return;
      eventBus.$emit('eliminar-estimacion-contrato', estimacion);
    },
    descargarTodos(eligeEstimacion) {
      const asignaEstimacionSeleccionada = new Promise((resolve) => {
        this.estimacion = eligeEstimacion;
        this.contratoEstimaciones = this.estimaciones;
        this.calcular();
        resolve('ok');
      });
      asignaEstimacionSeleccionada.then(() => {
        const pdfControlEstimaciones = new Promise((resolve) => {
          this.generarPdfControl();
          resolve('ok');
        });
        const pdfConcentrado = new Promise((resolve) => {
          this.generarPdfConcentrado();
          resolve('ok');
        });
        const pdfCheckList = new Promise((resolve) => {
          this.generarPdfCheckList(this.estimacion, this.contrato);
          resolve('ok');
        });
        const pdfGraficaAvance = new Promise((resolve) => {
          this.generarPdfGraficaAvance();
          resolve('ok');
        });
        const pdfRelacionConceptos = new Promise((resolve) => {
          this.generarPdfRelacionConceptos();
          resolve('ok');
        });
        const pdfPenasConvencionales = new Promise((resolve) => {
          this.generarPdfPenasConvencionales();
          resolve('ok');
        });

        pdfControlEstimaciones.then(() => true);
        pdfConcentrado.then(() => true);
        pdfCheckList.then(() => true);
        pdfGraficaAvance.then(() => true);
        pdfRelacionConceptos.then(() => true);
        pdfPenasConvencionales.then(() => true);
        return true;
      });
    },
  },
  computed: {
    getEstimaciones() {
      const numeroDeEstimaciones = this.estimaciones.map(({ numero }) => numero);
      const ultimaEstimacion = Math.max(...numeroDeEstimaciones);
      return this.estimaciones.map((estimacion) => ({
        ...estimacion,
        esUltima: ultimaEstimacion === estimacion.numero,
      }));
    },
    getHeaders() {
      return this.headers
        .filter(({ mostrarSmall }) => {
          if (this.tipoHeader === 0) return mostrarSmall === true;
          return true;
        })
        .filter(({ esObraFinanciada }) => {
          if (this.esObraFinanciada) return true;
          return esObraFinanciada === false;
        });
    },
    headersSmall() {
      return this.headers.filter((header) => header.mostrarSmall === true);
    },
  },
};
</script>

<style lang="scss">

</style>
